// 设备信息档案
import request from '@/utils/httpRequest'

export function queryById(id) {
    return request({
        url: '/equipment/wuyeEquipmentArchive/queryById',
        method: 'get',
        params: {id: id}
    })
}

export function startFlow(params) {
    return request({
        url: '/equipment/wuyeEquipmentArchive/startFlow',
        method: 'post',
        data: params
    })
}

export function equipmentList(params) {
    return request({
        url: '/equipment/wuyeEquipmentArchive/list',
        method: 'get',
        params: params
    });
}